var map = {
	"./baccarat_en.png": "6Q5H",
	"./baccarat_th.png": "b0/7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5zPn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/baccarat_.*\.png$
// module id = 5zPn
// module chunks = 1